import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./Alert.module.scss";
import { Icon } from "@livingmap/hippo";

export enum AlertTypes {
  INFO = "INFO",
  INFO_ALT = "INFO_ALT",
  WARNING = "WARNING",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

interface Props {
  type: AlertTypes;
  closable?: boolean;
  onClose?: () => void;
  title?: string;
  description: ReactNode;
  dataQA: string;
}

const getIcon = (type: AlertTypes) => {
  switch (type) {
    case AlertTypes.INFO:
    case AlertTypes.INFO_ALT:
      return "info";
    case AlertTypes.ERROR:
      return "error";
    case AlertTypes.WARNING:
      return "warning";
    case AlertTypes.SUCCESS:
      return "check";
    default:
      return "info";
  }
};

const Alert = ({
  title,
  description,
  type = AlertTypes.INFO,
  closable,
  onClose,
  dataQA,
}: Props) => {
  const classnames = classNames(styles.container, styles[type]);

  return (
    <div className={classnames} data-qa={dataQA}>
      <div
        className={classNames(styles.content, {
          [styles.contentWithTitle]: title,
        })}
      >
        <Icon
          dataQA="alert-icon"
          name={getIcon(type)}
          size={24}
          className={styles.icon}
        />
        <div className={styles.textWrapper}>
          {title && (
            <h1
              className={classNames(styles.title, {
                [styles.withDescription]: description,
              })}
              data-qa="title"
            >
              {title}
            </h1>
          )}
          <div className={styles.description} data-qa={description}>
            {description}
          </div>
        </div>
      </div>
      {closable && (
        <div
          onClick={onClose}
          className={styles.iconWrapper}
          data-qa="close-button"
        >
          <Icon
            dataQA="close-icon"
            name="close"
            size={24}
            className={styles.closeIcon}
          />
        </div>
      )}
    </div>
  );
};

export default Alert;
